module.exports = __webpack_public_path__ + "h5/img/wang_.0aa89a93.jpg";